exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ebx-icon{width:1em;height:1em}.ebx-icon--filled{fill:currentColor}.ebx-icon--stroked{stroke:currentColor}", ""]);
